module.exports = __webpack_public_path__ + "media/images/products/banners/cripto_research-51079fc276565e7a944711a9dc172d23.png";